import React from 'react';

export default function MarketsSection() {
  return (
    <section id="markets" className="sec" style={{ background: 'var(--cream)' }}>
      <div className="mkt-hdr rv">
        <div>
          <div className="kicker k-dk">End Markets</div>
          <h2 className="title dk">
            Industries
            <br />
            we <em>serve</em>
          </h2>
        </div>
        <p className="mkt-sub">
          Our masterbatches perform in the world&apos;s most demanding processing environments — from micron-thin BOPET
          film to structural automotive compounds requiring long-term UV and heat stability.
        </p>
      </div>
      <div className="mkt-grid rv">
        <div className="mkt-c">
          <span className="mkt-no">01</span>
          <h4>Flexible Packaging</h4>
          <p>BOPET · BOPP · multilayer pouches · stand-up packs</p>
        </div>
        <div className="mkt-c">
          <span className="mkt-no">02</span>
          <h4>Rigid Packaging</h4>
          <p>PET bottles · closures · preforms · caps</p>
        </div>
        <div className="mkt-c">
          <span className="mkt-no">03</span>
          <h4>Automotive</h4>
          <p>Interior trim · exterior panels · under-hood parts</p>
        </div>
        <div className="mkt-c">
          <span className="mkt-no">04</span>
          <h4>Construction</h4>
          <p>Pipes · profiles · geomembranes · sheets</p>
        </div>
        <div className="mkt-c">
          <span className="mkt-no">05</span>
          <h4>Agriculture</h4>
          <p>Mulch film · silage wrap · greenhouse cover</p>
        </div>
        <div className="mkt-c">
          <span className="mkt-no">06</span>
          <h4>Healthcare</h4>
          <p>Medical-grade · FDA-compliant · clean-room film</p>
        </div>
        <div className="mkt-c">
          <span className="mkt-no">07</span>
          <h4>Fiber &amp; Textiles</h4>
          <p>Spunbond · polyester yarn · dope-dyed fiber</p>
        </div>
        <div className="mkt-c">
          <span className="mkt-no">08</span>
          <h4>Electronics</h4>
          <p>ESD protection · flame retardant · housings</p>
        </div>
      </div>
    </section>
  );
}
